export const getDesignCanvas = (aspectRatio = '9:16') => {
    const [width, height] = aspectRatio.split(':').map(Number);
    if (!(Number.isFinite(width) && Number.isFinite(height) && width > 0 && height > 0)) {
        throw new Error('Invalid aspect ratio');
    }
    // Match the integer width assigned to the preview's canvas element.
    return { width: Math.floor(720 * width / height), height: 720 };
};

export const getDocumentAspectRatio = document => {
    const canvas = document?.canvas;
    if (canvas?.aspectRatio) return canvas.aspectRatio;
    if (canvas?.width > 0 && canvas?.height > 0) {
        const gcd = (a, b) => b ? gcd(b, a % b) : a;
        const divisor = gcd(canvas.width, canvas.height);
        return `${canvas.width / divisor}:${canvas.height / divisor}`;
    }
    return { square: '1:1', landscape: '16:9' }[canvas?.orientation?.toLowerCase()] || '9:16';
};

// The crop guide and export request must use the same original design canvas.
// An offset is measured against that canvas, and is included exactly once here.
export const getCropRect = (canvas, ratio, offset = {}) => {
    const [w, h] = ratio.split(':').map(Number);
    const targetRatio = w / h;
    if (!(Number.isFinite(targetRatio) && targetRatio > 0)) throw new Error('Invalid crop ratio');
    const width = Math.min(canvas.width, canvas.height * targetRatio);
    const height = width / targetRatio;
    return {
        x: (canvas.width - width) / 2 + (offset.x || 0) * canvas.width,
        y: (canvas.height - height) / 2 + (offset.y || 0) * canvas.height,
        width,
        height,
    };
};
